webpackJsonp([35783957827783],{

/***/ 450:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDJweCIgaGVpZ2h0PSIzOHB4IiB2aWV3Qm94PSIwIDAgNDIgMzgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hY3Rpdml0eTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJMYW5kaW5nIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSIwMDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTk1LjAwMDAwMCwgLTMwMjguMDAwMDAwKSIgc3Ryb2tlPSIjOTI5MjkyIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyBpZD0iYWN0aXZpdHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExOTYuMDAwMDAwLCAzMDI5LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJTaGFwZSIgcG9pbnRzPSI0MCAxOCAzMiAxOCAyNiAzNiAxNCAwIDggMTggMCAxOCI+PC9wb2x5bGluZT4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzNweCIgaGVpZ2h0PSIzN3B4IiB2aWV3Qm94PSIwIDAgMzMgMzciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5lZGl0LTM8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iTGFuZGluZyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0iMDAzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTM1LjAwMDAwMCwgLTMwMjcuMDAwMDAwKSIgc3Ryb2tlPSIjOTI5MjkyIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyBpZD0iZWRpdC0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MzYuMDAwMDAwLCAzMDI4LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlNoYXBlIiBwb2ludHM9IjE4Ljg1NzE0MjkgMCAyNS43MTQyODU3IDYuODU3MTQyODYgNi44NTcxNDI4NiAyNS43MTQyODU3IDAgMjUuNzE0Mjg1NyAwIDE4Ljg1NzE0MjkiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDM0LjI4NTcxNDMgTDMwLjg1NzE0MjksMzQuMjg1NzE0MyIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzhweCIgaGVpZ2h0PSIzOHB4IiB2aWV3Qm94PSIwIDAgMzggMzgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5saW5rPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkxhbmRpbmciIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9IjAwMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxNy4wMDAwMDAsIC0zMDI3LjAwMDAwMCkiIHN0cm9rZT0iIzkyOTI5MiIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGcgaWQ9ImxpbmsiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxOC4wMDAwMDAsIDMwMjguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTQuNCwxOS44IEMxNS45NjQxMTk5LDIxLjg5MTA0NzMgMTguMzU5MzI5MSwyMy4xOTk2NjA4IDIwLjk2Mzk2OTgsMjMuMzg2MiBDMjMuNTY4NjEwNCwyMy41NzI3MzkzIDI2LjEyNTg1ODQsMjIuNjE4ODExIDI3Ljk3MiwyMC43NzIgTDMzLjM3MiwxNS4zNzIgQzM2Ljc4Mjc0OTksMTEuODQwNTkgMzYuNzMzOTcxNCw2LjIyNzIzNzAxIDMzLjI2MjM2NzIsMi43NTU2MzI4MiBDMjkuNzkwNzYzLC0wLjcxNTk3MTM2NSAyNC4xNzc0MSwtMC43NjQ3NDk4ODYgMjAuNjQ2LDIuNjQ2IEwxNy41NSw1LjcyNCIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjEuNiwxNi4yIEMyMC4wMzU4ODAxLDE0LjEwODk1MjcgMTcuNjQwNjcwOSwxMi44MDAzMzkyIDE1LjAzNjAzMDIsMTIuNjEzOCBDMTIuNDMxMzg5NiwxMi40MjcyNjA3IDkuODc0MTQxNTYsMTMuMzgxMTg5IDguMDI4LDE1LjIyOCBMMi42MjgsMjAuNjI4IEMtMC43ODI3NDk4ODYsMjQuMTU5NDEgLTAuNzMzOTcxMzY1LDI5Ljc3Mjc2MyAyLjczNzYzMjgyLDMzLjI0NDM2NzIgQzYuMjA5MjM3MDEsMzYuNzE1OTcxNCAxMS44MjI1OSwzNi43NjQ3NDk5IDE1LjM1NCwzMy4zNTQgTDE4LjQzMiwzMC4yNzYiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzhweCIgaGVpZ2h0PSIzOHB4IiB2aWV3Qm94PSIwIDAgMzggMzgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5tZXNzYWdlLXNxdWFyZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJMYW5kaW5nIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSIwMDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04NTIuMDAwMDAwLCAtMzAyNy4wMDAwMDApIiBzdHJva2U9IiM5MjkyOTIiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJtZXNzYWdlLXNxdWFyZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODUzLjAwMDAwMCwgMzAyOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zNiwyNCBDMzYsMjYuMjA5MTM5IDM0LjIwOTEzOSwyOCAzMiwyOCBMOCwyOCBMMCwzNiBMMCw0IEMwLDEuNzkwODYxIDEuNzkwODYxLDAgNCwwIEwzMiwwIEMzNC4yMDkxMzksMCAzNiwxLjc5MDg2MSAzNiw0IEwzNiwyNCBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/anand.ef07aac1.jpeg";

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/campaigns.c08c940b.svg";

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/live-chat.4ab0be39.svg";

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/man-explaining.56eee062.svg";

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/man-thinking.1a207882.svg";

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rocket-on-back.414dca2b.svg";

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/thread.91e918d8.png";

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tarek.f50a30fd.png";

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vivek.06ca52ea.jpg";

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/004.bd5dc10f.png";

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/104.5e450574.png";

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/106.0ff5e404.png";

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/107.ec42b985.png";

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var injectIsMobile = function injectIsMobile(Child) {
	  return function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this.state = { isMobile: false };
	
	      _this.onResize = _this.onResize.bind(_this);
	      return _this;
	    }
	
	    _class.prototype.componentWillMount = function componentWillMount() {
	      var resizeListener = typeof window !== 'undefined' && window.addEventListener('resize', this.onResize);
	      this.onResize();
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	      typeof window !== 'undefined' && window.removeEventListener('resize', this.onResize);
	    };
	
	    _class.prototype.onResize = function onResize() {
	      var isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
	      this.setState({ isMobile: isMobile });
	    };
	
	    _class.prototype.render = function render() {
	      return _react2.default.createElement(Child, _extends({ isMobile: this.state.isMobile }, this.props));
	    };
	
	    return _class;
	  }(_react2.default.Component);
	};
	
	exports.default = injectIsMobile;
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(22);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _thread = __webpack_require__(466);
	
	var _thread2 = _interopRequireDefault(_thread);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'cf' },
	    _react2.default.createElement(
	      'div',
	      { className: 'w-100 w-50-ns fl-ns' },
	      _react2.default.createElement(
	        'div',
	        { className: 'w-80 center mt2 mt6-ns pl0 pl4-ns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'f3 f1-ns' },
	          'Customers are immune to sales emails.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'f4 f3-ns lighter-gray' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Speer helps you observe a customer\u2019s body language & change your message accordingly.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'It makes sales relavent, not loud.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mt4 mt5-ns' },
	          _react2.default.createElement(_button2.default, { label: 'Get started', href: '', backgroundColor: 'blue' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'lighter-gray f6 mt1 pl2' },
	            'Free for 7 days, no card required'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'w-100 w-50-ns fl-ns tr' },
	      _react2.default.createElement('img', { src: _thread2.default })
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _activity = __webpack_require__(450);
	
	var _activity2 = _interopRequireDefault(_activity);
	
	var _edit = __webpack_require__(451);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _link = __webpack_require__(452);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _messageSquare = __webpack_require__(454);
	
	var _messageSquare2 = _interopRequireDefault(_messageSquare);
	
	var _ = __webpack_require__(469);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(471);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(470);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(472);
	
	var _8 = _interopRequireDefault(_7);
	
	var _subHeader = __webpack_require__(77);
	
	var _subHeader2 = _interopRequireDefault(_subHeader);
	
	var _injectIsMobile = __webpack_require__(18);
	
	var _injectIsMobile2 = _interopRequireDefault(_injectIsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var steps = [{
	  label: 'Connect',
	  body: 'Connect you email account to Speer, all messages are sent from your personal email.',
	  icon: _link2.default,
	  screenshot: _2.default
	}, {
	  label: 'Create',
	  body: 'Create your outreach flow or chose from existing templates.',
	  icon: _edit2.default,
	  screenshot: _6.default
	}, {
	  label: 'Send',
	  body: 'Send at scale or individually.',
	  icon: _messageSquare2.default,
	  screenshot: _4.default
	}, {
	  label: 'Analyse',
	  body: 'Analyse your outreach. Find the most interested leads.',
	  icon: _activity2.default,
	  screenshot: _8.default
	}];
	
	var Tabs = function Tabs(_ref) {
	  var steps = _ref.steps,
	      activeTab = _ref.activeTab,
	      _onClick = _ref.onClick,
	      isMobile = _ref.isMobile;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'cf w-80 w-60-ns center' },
	      steps.map(function (s, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, className: 'fl w-25 tc gray cf' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'dib br-100 ba dim pointer ' + (activeTab === s.label ? 'b--light-blue' : 'b--lightest-gray') + ' ' + (isMobile ? 'w2 h2 pa2' : 'w4 h4 pa4'),
	              onClick: function onClick() {
	                return _onClick(s.label);
	              }
	            },
	            _react2.default.createElement('img', { src: s.icon, className: 'h1 w1 h2-ns w2-ns' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'b mt2', style: isMobile ? { fontSize: 8 } : {} },
	              s.label
	            )
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt4' },
	      steps.map(function (s, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'tc ' + (activeTab === s.label ? '' : 'dn'), key: i },
	          _react2.default.createElement(
	            'div',
	            { className: 'gray f4' },
	            s.body
	          ),
	          _react2.default.createElement('img', {
	            src: s.screenshot,
	            className: 'w-90 w-60-ns center ba b--black-20 shadow-2 br3 mt3'
	          })
	        );
	      })
	    )
	  );
	};
	
	var HowItWorks = function (_React$Component) {
	  _inherits(HowItWorks, _React$Component);
	
	  function HowItWorks(props) {
	    _classCallCheck(this, HowItWorks);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      activeTab: 'Connect'
	    };
	    return _this;
	  }
	
	  HowItWorks.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_subHeader2.default, { title: 'How it works ?' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'mt4' },
	        _react2.default.createElement(Tabs, {
	          isMobile: this.props.isMobile,
	          steps: steps,
	          activeTab: this.state.activeTab,
	          onClick: function onClick(activeTab) {
	            return _this2.setState({ activeTab: activeTab });
	          }
	        })
	      )
	    );
	  };
	
	  return HowItWorks;
	}(_react2.default.Component);
	
	exports.default = (0, _injectIsMobile2.default)(HowItWorks);
	module.exports = exports['default'];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _manThinking = __webpack_require__(463);
	
	var _manThinking2 = _interopRequireDefault(_manThinking);
	
	var _manExplaining = __webpack_require__(462);
	
	var _manExplaining2 = _interopRequireDefault(_manExplaining);
	
	var _button = __webpack_require__(22);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _injectIsMobile = __webpack_require__(18);
	
	var _injectIsMobile2 = _interopRequireDefault(_injectIsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseStudy = function CaseStudy(_ref) {
	  var title = _ref.title,
	      body = _ref.body,
	      isMobile = _ref.isMobile;
	  return _react2.default.createElement(
	    'div',
	    { className: 'cf mt3 pointer dim w-100 w-60-ns center-ns tl' },
	    _react2.default.createElement(
	      'div',
	      { className: 'w-10 fl' },
	      _react2.default.createElement('div', {
	        className: 'shadow-2 br2',
	        style: { height: isMobile ? 36 : 66, width: isMobile ? 28 : 50 }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'w-90 fl mt0 mt2-ns pl3' },
	      _react2.default.createElement(
	        'div',
	        { className: 'b' },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'lighter-gray' },
	        body
	      )
	    )
	  );
	};
	
	var NotSure = function NotSure(_ref2) {
	  var isMobile = _ref2.isMobile;
	  return _react2.default.createElement(
	    'div',
	    { className: 'mv5' },
	    _react2.default.createElement(
	      'div',
	      { className: 'w-100 w-80-ns center-ns' },
	      _react2.default.createElement(
	        'div',
	        { className: 'cf' },
	        _react2.default.createElement(
	          'div',
	          { className: 'fl w-20' },
	          _react2.default.createElement('img', { src: _manThinking2.default, className: 'h-100' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fl w-60 ph3 ph0-ns mt5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tc' },
	            _react2.default.createElement(
	              'div',
	              { className: 'black-40 f3 f2-ns mb4' },
	              'Not sure if Speer is for you ?'
	            ),
	            _react2.default.createElement(_button2.default, {
	              label: 'Contact a buying assistant',
	              href: '',
	              backgroundColor: 'white'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'lighter-gray f6 mt1 pl2' },
	              'We\'ll never try to sell you. Promise.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fl w-20' },
	          _react2.default.createElement('img', { src: _manExplaining2.default, className: 'h-100' })
	        )
	      )
	    ),
	    _react2.default.createElement('div', {
	      style: { backgroundColor: '#FFE3C9', height: 4, marginTop: -36 },
	      className: 'w-100'
	    })
	  );
	};
	
	exports.default = (0, _injectIsMobile2.default)(NotSure);
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _subHeader = __webpack_require__(77);
	
	var _subHeader2 = _interopRequireDefault(_subHeader);
	
	var _injectIsMobile = __webpack_require__(18);
	
	var _injectIsMobile2 = _interopRequireDefault(_injectIsMobile);
	
	var _vivek = __webpack_require__(468);
	
	var _vivek2 = _interopRequireDefault(_vivek);
	
	var _anand = __webpack_require__(456);
	
	var _anand2 = _interopRequireDefault(_anand);
	
	var _tarek = __webpack_require__(467);
	
	var _tarek2 = _interopRequireDefault(_tarek);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Testimony = function Testimony(_ref) {
	  var title = _ref.title,
	      body = _ref.body,
	      name = _ref.name,
	      designation = _ref.designation,
	      avatar = _ref.avatar,
	      marginTop = _ref.marginTop,
	      isMobile = _ref.isMobile;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'w-100 fl-ns pa4 w-33-ns',
	      style: { marginTop: isMobile ? 0 : marginTop }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'pa3 ba b--lightest-gray br2' },
	      _react2.default.createElement('div', { className: '', dangerouslySetInnerHTML: { __html: body } })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cf f6' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fl w-30 tr' },
	        _react2.default.createElement('img', {
	          src: avatar,
	          className: 'h3 w3 br-100 bg-gray shadow-2 ba b--blue',
	          style: { marginTop: -8 }
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'fl w-70 pl2 pt2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'b f5 mb1' },
	          name
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          designation
	        )
	      )
	    )
	  );
	};
	
	var testimonies = [{
	  body: 'A major part of my job is to reach out and sell on email and I\'ve used everything I can get my hands on. <br/><br/> I liked the authenticity of their message. It\'s true that most customers hate outreach emails. This app helps me reach out only to those who intend to buy.',
	  avatar: _anand2.default,
	  name: 'Anand Chowdhary',
	  designation: 'CEO, Oswald Labs',
	  marginTop: -20
	}, {
	  body: 'Their analytics helped us find leads we should focus on. They were strinkingly, on point with that.',
	  avatar: _vivek2.default,
	  name: 'Vivek Goel',
	  designation: 'CEO, Emanant Technologies',
	  marginTop: 0
	}, {
	  body: 'Running a campaign was very easy and automation around intent helped us generate quality leads.<br/> <br/>We do not spend much time on follow ups now, they (Speer) do it for us.',
	  avatar: _tarek2.default,
	  name: 'Tarek Gethe',
	  designation: 'Head of Sales, Germany, A11Y.co',
	  marginTop: -20
	}];
	
	var Testimonies = function Testimonies(_ref2) {
	  var isMobile = _ref2.isMobile;
	  return _react2.default.createElement(
	    'div',
	    { className: 'mt4 mt0-ns w-100 w-90-ns center' },
	    _react2.default.createElement(_subHeader2.default, { title: 'Testimonies' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'cf pv4' },
	      testimonies.map(function (t, i) {
	        return _react2.default.createElement(Testimony, _extends({ key: i, isMobile: isMobile }, t));
	      })
	    )
	  );
	};
	
	exports.default = (0, _injectIsMobile2.default)(Testimonies);
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _subHeader = __webpack_require__(77);
	
	var _subHeader2 = _interopRequireDefault(_subHeader);
	
	var _button = __webpack_require__(22);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _campaigns = __webpack_require__(458);
	
	var _campaigns2 = _interopRequireDefault(_campaigns);
	
	var _liveChat = __webpack_require__(461);
	
	var _liveChat2 = _interopRequireDefault(_liveChat);
	
	var _injectIsMobile = __webpack_require__(18);
	
	var _injectIsMobile2 = _interopRequireDefault(_injectIsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UseCase = function UseCase(_ref) {
	  var illustration = _ref.illustration,
	      title = _ref.title,
	      body = _ref.body,
	      href = _ref.href,
	      illustrationTowardsRight = _ref.illustrationTowardsRight,
	      isMobile = _ref.isMobile;
	  return _react2.default.createElement(
	    'div',
	    { className: 'fl-ns w-100 w-50-ns mb4 mb0-ns' },
	    _react2.default.createElement(
	      'div',
	      { className: 'w-100 ' + (illustrationTowardsRight ? 'tr' : '') },
	      _react2.default.createElement('img', { src: illustration })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: isMobile ? -80 : -120 }, className: 'w-80 center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'f3 f2-ns' },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'lighter-gray f5 f4-ns mt3 tl' },
	        body,
	        _react2.default.createElement(
	          'div',
	          { className: 'mt2 mt4-ns' },
	          _react2.default.createElement(
	            'a',
	            { href: href, className: 'light-blue b' },
	            'Learn more'
	          )
	        )
	      )
	    )
	  );
	};
	
	var UseCases = function UseCases(_ref2) {
	  var isMobile = _ref2.isMobile;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_subHeader2.default, { title: 'Use cases' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'cf' },
	      _react2.default.createElement(UseCase, {
	        isMobile: isMobile,
	        title: 'Mindfull outbound campaigns',
	        illustration: _campaigns2.default,
	        body: 'Mindless automation turns feels spammy, irritating and robotic. Use Speer to run intenful (delightful) campaigns that don\u2019t annoy.',
	        href: '/posts/2018/mindfull-outbound-campaigns'
	      }),
	      _react2.default.createElement(UseCase, {
	        isMobile: isMobile,
	        title: 'Find your most loved live-chat leads',
	        illustration: _liveChat2.default,
	        illustrationTowardsRight: true,
	        body: 'You can configure Speer to talk to your live chat leads automatically. We\u2019ll find the best ones, and nurture the others.',
	        href: 'http://google.com'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'pv0 pv4-ns tc mv3 mv5-ns' },
	      _react2.default.createElement(_button2.default, { label: 'Get started', href: '', backgroundColor: 'blue' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'lighter-gray f6 mt1 pl2' },
	        'Free for 7 days, no card required'
	      )
	    )
	  );
	};
	
	exports.default = (0, _injectIsMobile2.default)(UseCases);
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(22);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _rocketOnBack = __webpack_require__(137);
	
	var _rocketOnBack2 = _interopRequireDefault(_rocketOnBack);
	
	var _injectIsMobile = __webpack_require__(18);
	
	var _injectIsMobile2 = _interopRequireDefault(_injectIsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReadyToTry = function ReadyToTry(_ref) {
	  var isMobile = _ref.isMobile;
	  return _react2.default.createElement(
	    'div',
	    { className: 'tc pv6', style: {} },
	    _react2.default.createElement(
	      'div',
	      { className: 'pv4' },
	      _react2.default.createElement(
	        'div',
	        { className: 'lighter-gray f4 mb3' },
	        'Ready to try Speer ?'
	      ),
	      _react2.default.createElement(_button2.default, { label: 'Get started', href: '', backgroundColor: 'blue', size: 'large' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'lighter-gray f6 mt1 pl2' },
	        'Free for 7 days, no card required'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fr', style: { marginTop: isMobile ? 8 : -199 } },
	      _react2.default.createElement('img', { src: _rocketOnBack2.default, className: '' + (isMobile ? 'h4' : '') })
	    )
	  );
	};
	
	exports.default = (0, _injectIsMobile2.default)(ReadyToTry);
	module.exports = exports['default'];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dotStyle = {
	  height: 12,
	  width: 12,
	  borderRadius: '100%'
	};
	
	var SubHeader = function SubHeader(_ref) {
	  var title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: 'f4 f3-ns tc' },
	    _react2.default.createElement('div', { className: 'bg-light-blue dib', style: dotStyle }),
	    _react2.default.createElement(
	      'span',
	      { className: 'ph3' },
	      title
	    ),
	    _react2.default.createElement('div', { className: 'bg-light-blue dib', style: dotStyle })
	  );
	};
	
	exports.default = SubHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(48);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bgVariations = {
	  blue: { backgroundColor: '#2a52d2', color: '#fff' },
	  white: { border: '1px solid #999' }
	};
	
	var sizeVariations = {
	  small: 'pv2 ph4 f4',
	  large: 'pv3 ph5 f3'
	};
	
	var Button = function Button(_ref) {
	  var label = _ref.label,
	      href = _ref.href,
	      backgroundColor = _ref.backgroundColor,
	      size = _ref.size;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: href },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'br-pill b dib bw2 grow ' + sizeVariations[size ? size : 'small'],
	          style: bgVariations[backgroundColor]
	        },
	        label
	      )
	    )
	  );
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hero = __webpack_require__(214);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _useCases = __webpack_require__(218);
	
	var _useCases2 = _interopRequireDefault(_useCases);
	
	var _testimonies = __webpack_require__(217);
	
	var _testimonies2 = _interopRequireDefault(_testimonies);
	
	var _notSure = __webpack_require__(216);
	
	var _notSure2 = _interopRequireDefault(_notSure);
	
	var _howItWorks = __webpack_require__(215);
	
	var _howItWorks2 = _interopRequireDefault(_howItWorks);
	
	var _readyToTry = __webpack_require__(76);
	
	var _readyToTry2 = _interopRequireDefault(_readyToTry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_hero2.default, null),
	    _react2.default.createElement(_testimonies2.default, null),
	    _react2.default.createElement(_useCases2.default, null),
	    _react2.default.createElement(_notSure2.default, null),
	    _react2.default.createElement(_howItWorks2.default, null),
	    _react2.default.createElement(_readyToTry2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-5016d7ce3dab67305a90.js